import type { TabConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";

// ============================================================================
// ADMIN USER DETAIL TABS CONFIGURATION
// ============================================================================
// Rendered by useAdminUserDetailModalTabs.renderPrimaryArea (switches on tab id).
// ============================================================================

export const adminUserDetailTabs: TabConfig<any>[] = [
  {
    id: "overview",
    label: "Overview",
    icon: "user",
    variant: "blue",
    group: "core",
    priority: 1,
    content: {
      type: "custom",
      customComponent: "AdminUserOverviewDisplay",
    },
  },
  {
    id: "access",
    label: "Access & Permissions",
    icon: "shield",
    variant: "green",
    group: "core",
    priority: 2,
    content: {
      type: "custom",
      customComponent: "AdminUserAccessDisplay",
    },
  },
  {
    id: "activity",
    label: "Activity",
    icon: "activity",
    variant: "purple",
    group: "core",
    priority: 3,
    content: {
      type: "custom",
      customComponent: "AdminUserActivityDisplay",
    },
  },
];
